import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/img/logo.svg'


const _hoisted_1 = { class: "welcomePage" }
const _hoisted_2 = /*#__PURE__*/_createVNode("div", { class: "swiper-slide loginBg1" }, null, -1)
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "contentContainer bubblesBg align-items-start" }, [
  /*#__PURE__*/_createVNode("div", { class: "text-center w-100 pt-5" }, [
    /*#__PURE__*/_createVNode("img", {
      src: _imports_0,
      class: "logo"
    })
  ])
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_swiper_slides = _resolveComponent("swiper-slides")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_swiper_slides, {
      class: "welcomeBgImages",
      showPagination: false,
      arrow: false
    }, {
      default: _withCtx(() => [
        _hoisted_2
      ]),
      _: 1
    }),
    _hoisted_3
  ]))
}